<div *ngIf="showAvatar" class="notes-list-user-img">
  <img [src]="note.userImg" alt="User" class="user-img">
</div>
<div class="notes-list-item-content">
  <p>
    <span [title]="note.fullName || note.name" class="body-copy-bold">{{ note.name }}</span> | <span
    class="detail">{{ note.time }}</span>
  </p>
  <audio *ngIf="note.type === 'audio'" class="observation-audio" controls="" preload="metadata">
    <source [src]="note.data" type="audio/mp4">
    <p>{{ "DASHPAGES.COACHING_DETAIL_note" | translate }}</p>
  </audio>
  <div *ngIf="note.type === 'text'" [innerHTML]="text | markdown | async"
       class="notes-list-item-text"></div>
  <button *ngIf="canShowOriginal" (click)="toggleOriginal()" class="show-original-toggle" type="button">
    {{ (showingOriginal ? 'SHARED.Show_translation' : 'SHARED.Show_original') | translate }}
  </button>
</div>
